import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// Self-hosted webfonts (OO1): Inter for UI and body, Oswald for the uppercase display type -
// the Apex / KW Commercial design system's substitutes for the licensed Helvetica Neue. From
// JS so Vite copies the .woff2 files into the build (see the note in index.css).
import '@fontsource-variable/inter';
import '@fontsource/oswald/400.css';
import '@fontsource/oswald/500.css';
import '@fontsource/oswald/600.css';
import '@fontsource/oswald/700.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the PWA service worker in production builds only, so local dev on
// :3000 is never intercepted. sw.js never touches /api/ or cross-origin
// requests (the Railway API always goes straight to the network).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Non-fatal: the app works fine without offline support.
    });
  });
}
